import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable, Injector} from '@angular/core';
import {SettingsService, StorageService} from '../services';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private storage: StorageService;
  private settings: SettingsService;

  constructor(private injector: Injector) {
    this.settings = injector.get(SettingsService);
    this.storage = injector.get(StorageService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes(this.settings.apiUrl) && req.url !== `${this.settings.apiUrl}/authtoken`) {
      this.storage.lastActivity = new Date().getTime();
      if (this.storage.accessToken && this.storage.accessToken !== 'undefined') {
        const authHeader = `Bearer ${this.storage.accessToken}`;
        const authReq = req.clone({headers: req.headers.set('X-Authorization', authHeader)});
        return next.handle(authReq);
      }
    }
    return next.handle(req);
  }
}
